import { render, staticRenderFns } from "./TicketCommentsold.vue?vue&type=template&id=274bfe90&scoped=true"
import script from "./TicketCommentsold.vue?vue&type=script&lang=js"
export * from "./TicketCommentsold.vue?vue&type=script&lang=js"
import style0 from "./TicketCommentsold.vue?vue&type=style&index=0&id=274bfe90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274bfe90",
  null
  
)

export default component.exports